import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type SchoolProposalFormValues = {
  school?: string;
  schooltype?: string;
};

const schoolProposalValidationSchema = (mode: 'update') =>
  yup.object({
    school: yup
      .string()
      .when([], {
        is: () => mode === 'update',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('School'),
    schooltype: yup
      .string()
      .when([], {
        is: () => mode === 'update',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Type'),
  });

export const useHandleSchoolProposalForm = (mode: 'update') => {
  const { register, handleSubmit, errors, setValue, reset } =
    useFormHandler<SchoolProposalFormValues>(
      schoolProposalValidationSchema(mode),
    );
  return {
    register,
    handleSubmit,
    setValue,
    errors,
    reset,
  };
};
